
import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});


const step1 = { title: 'Step 1 Instructions',
                body: (<div>

                        <p>To start, you can set colours for each letter of the alphabet individually. When you go on to colour words in the next step, each of the letters in the word will be coloured as you set it here. You can come back to this step to update your letter colours whenever you like.</p>
                        <p>All letters with a question mark in the corner have not had a colour selected yet. To set the letter colour, click on the letter. Untick "No Colour" to view the colour palette. Adjust the white circles in the colour palette to choose the colour, then click "OK". If you'd like to adjust the colour further, simply click the letter again to reopen the palette as many times as you'd like.</p>
                        <p>Once you've set colours for letters, you can go on to colouring words by clicking "Next".</p>

                            </div>)};

const step2 = { title: 'Step 2 Instructions',
                body: (<div>
                        <p><em>Selecting a word</em></p>
                        <p>Please begin by adjusting the colours for the three calibration words - "magic", "check", and "baseline" - to match your synaesthetic experience of these words. Switch between words by clicking on them. The selected word will appear in a grey box in the middle of your screen. If you set the colours of individual letters in Step 1, the letters will be automatically coloured already.</p>
                        <p>&nbsp;</p>
                        <p><em>Changing, expanding, and setting colours</em></p>
                        <p>To adjust the colours of the letters for the selected word, click on the large grey circle beneath the letter to open the colour palette and adjust the colour. If you change your mind, you can click "Reset Colours", which will reset all of the letters back to the colours you chose in Step 1. You can also return to Step 1 at any time to adjust the default letter colours.</p>
                        <p>In each word, each letter also has two smaller circles beneath it, on either side of the colour selector. You can click and drag these to spread that letter's colour further in the word, even through other letters. If you've spread a colour too far, you can click and drag outward from the large circle beneath the letter to re-establish its colour.</p>
                        <p>Once you have adjusted the selected word's colour to match your synaesthetic experience as closely as possible, click "Set Word" to lock in that word's colour. If you can change your mind, you can unset the word to adjust its colour again.</p>
                        <p>&nbsp;</p>
                        <p><em>Getting more words</em></p>
                        <p>Once you've set the colours of the first three calibration words, an "Add Word" button will appear, which will add a new random word from our wordlist. You are welcome to add and colour as many words as you like - the more the better!</p>
                        <p>Once you've experimented with the colour picker and set at least the first three words, you can click "Next" to give
                            us some feedback about this colour picker.</p>
                        </div>)};

export default function InstructionsDialog(props) {

    const { open, handleClose, step } = props;

    let stepToTuse = step === 1 ? step1 : step2;


    return (

    <Dialog
    open={open}
    TransitionComponent={Transition}
    keepMounted
    onClose={handleClose}
    aria-labelledby="alert-dialog-slide-title"
    aria-describedby="alert-dialog-slide-description"
        >
        <DialogTitle id="alert-dialog-slide-title">{stepToTuse.title}</DialogTitle>
        <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">
        {stepToTuse.body}
    </DialogContentText>
    </DialogContent>
    <DialogActions>
        <Button onClick={handleClose} color="primary">
        OK
        </Button>
        </DialogActions>
        </Dialog>

    );
}